import { Route, Routes } from 'react-router-dom';
import { BoardSettingsRoutes } from './BoardSettings';
import { CompanySettingsUsers } from './users/page';
import { CompanyProfile } from './CompanyProfile';
import { Billing } from '../billing/Billing';

export const Settings = () => {
  return (
    <Routes>
      <Route path="board">
        <Route path="*" element={<BoardSettingsRoutes />} />
      </Route>
      <Route path="users" element={<CompanySettingsUsers />} />
      <Route path="profile" element={<CompanyProfile />} />
      <Route path="billing" element={<Billing />} />
    </Routes>
  );
};
